/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';
import type { MemberPayment } from './MemberPayment';
import {
    MemberPaymentFromJSON,
    MemberPaymentFromJSONTyped,
    MemberPaymentToJSON,
} from './MemberPayment';

/**
 * 
 * @export
 * @interface GetAccountMembershipPayments200Response
 */
export interface GetAccountMembershipPayments200Response {
    /**
     * 
     * @type {Array<MemberPayment>}
     * @memberof GetAccountMembershipPayments200Response
     */
    data: Array<MemberPayment>;
    /**
     * 
     * @type {Metadata}
     * @memberof GetAccountMembershipPayments200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the GetAccountMembershipPayments200Response interface.
 */
export function instanceOfGetAccountMembershipPayments200Response(value: object): value is GetAccountMembershipPayments200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function GetAccountMembershipPayments200ResponseFromJSON(json: any): GetAccountMembershipPayments200Response {
    return GetAccountMembershipPayments200ResponseFromJSONTyped(json, false);
}

export function GetAccountMembershipPayments200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountMembershipPayments200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberPaymentFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function GetAccountMembershipPayments200ResponseToJSON(value?: GetAccountMembershipPayments200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberPaymentToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

